module.exports = __webpack_public_path__ + "img/logo.529323fc.png";